import { render } from "./BankCashBalance.vue?vue&type=template&id=2dbb6da4&scoped=true"
import script from "./BankCashBalance.vue?vue&type=script&lang=js"
export * from "./BankCashBalance.vue?vue&type=script&lang=js"

import "./BankCashBalance.vue?vue&type=style&index=0&id=2dbb6da4&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbb6da4"]])

export default __exports__